import React from "react";

import ColorControl from "./ColorControl";

export default function LightingControls({
  Slider,

  lightColor,
  setLightColor,

  lightIntensity,
  setLightIntensity,

  ambientIntensity,
  setAmbientIntensity,

  lightX,
  setLightX,

  lightY,
  setLightY,

  lightZ,
  setLightZ,
}) {
  return (
    <>
      <ColorControl label="Color" value={lightColor} onChange={setLightColor} />

      <Slider
        label="Intensity"
        value={lightIntensity}
        min={0}
        max={2}
        step={0.01}
        display={lightIntensity.toFixed(2)}
        onChange={setLightIntensity}
      />

      <Slider
        label="Ambient"
        value={ambientIntensity}
        min={0}
        max={1}
        step={0.01}
        display={ambientIntensity.toFixed(2)}
        onChange={setAmbientIntensity}
      />

      <Slider
        label="X"
        value={lightX}
        min={-1}
        max={1}
        step={0.01}
        display={lightX.toFixed(2)}
        onChange={setLightX}
      />

      <Slider
        label="Y"
        value={lightY}
        min={-1}
        max={1}
        step={0.01}
        display={lightY.toFixed(2)}
        onChange={setLightY}
      />

      <Slider
        label="Z"
        value={lightZ}
        min={-1}
        max={1}
        step={0.01}
        display={lightZ.toFixed(2)}
        onChange={setLightZ}
      />
    </>
  );
}
